import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import './Login.css';

export default function Login() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      navigate('/');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <svg viewBox="0 0 180 44" fill="none" xmlns="http://www.w3.org/2000/svg" height="36">
            <defs>
              <linearGradient id="lg2" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#00D4FF"/>
                <stop offset="100%" stopColor="#0057FF"/>
              </linearGradient>
            </defs>
            <polygon points="0,40 11,4 23,4 12,40" fill="url(#lg2)"/>
            <polygon points="26,40 37,4 47,4 36,40" fill="url(#lg2)" opacity="0.75"/>
            <text x="56" y="31" fontFamily="Inter,sans-serif" fontSize="14" fontWeight="800" fill="#0B1437" letterSpacing="1">ROUTE ROVER</text>
          </svg>
        </div>

        <h1>Admin Login</h1>
        <p>Sign in to manage your delivery operations</p>

        <form onSubmit={submit}>
          <div className="form-field">
            <label>Email</label>
            <input className="form-control" type="email" required
              placeholder="admin@routerover.io"
              value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
          </div>
          <div className="form-field">
            <label>Password</label>
            <input className="form-control" type="password" required
              placeholder="••••••••"
              value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} />
          </div>
          <button className="btn btn--primary login-btn" type="submit" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
